import { Avatar, CircularProgress, IconButton } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import {
  blackBackArrowImage,
  editIconImage,
  foremanDefaultImage,
} from "../../assets";
import { makeStyles } from "@material-ui/core/styles";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import { invokeApi, s3baseUrl } from "../../bl_libs/invokeApi";
import { useSnakbar } from "../../Context/Context-Snakbar/ContextSnackbar";
import ChangeEmail from "./components/Change-Email/ChangeEmail";
import ChangePhone from "./components/Change-Phone/ChanegPhone";
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
}));

function EditProfile(props) {
  const classes = useStyles();
  const { showErrorSnak, showSuccessSnak } = useSnakbar();
  //for loading

  const [isLoading, setIsLoading] = React.useState(true);

  //for show error
  const [errMessage, setErrMessage] = React.useState("");

  const [screen, setScreen] = React.useState("");
  const [profile, setProfile] = useState();
  const [image, setImage] = useState({
    file: "",
    preview: "",
  });

  const GetForemanProfile = (type) => {
    let requestObj = {
      path: "/api/sale_team/get_sale_team_profile",
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        setProfile(res.profile);
        localStorage.setItem("user", JSON.stringify(res.profile));
        setIsLoading(false);
        if (type === "done") {
          props.history.push("/salesman");
        }
      } else {
        //showErrorSnak(res.message);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    UpdateCompanyProfile();
  };

  const handleUpload = (event) => {
    // S3UploadFile(event.target.files[0]);
    setImage({
      file: event.target.files[0],
      preview: URL.createObjectURL(event.target.files[0]),
    });
  };

  const S3UploadFile = (file) => {
    return new Promise(function (resolve, reject) {
      let requestObj = {
        path: "/app_api/upload_s3_file",
        method: "POST",
        headers: {},
      };

      let formData = new FormData();
      formData.append("upload_file", file);
      formData.append("upload_type", "profile");
      requestObj["postData"] = formData;
      invokeApi(requestObj).then((res) => {
        console.log(res);
        if (res.code === 200) {
          resolve(res.file_url);
        } else {
          setErrMessage(res.message);
          //showErrorSnak(res.message);
          setIsLoading(false);
        }
      });
    });
  };

  const validString = (string) => {
    const re = /^[a-z A-Z]+$/;
    return re.test(string);
  };

  const UpdateCompanyProfile = async () => {
    if (profile.first_name.trim().length < 2) {
      showErrorSnak("First name length must be grater then 1.");
      return;
    }
    if (profile.last_name.trim().length < 1) {
      showErrorSnak("Last name must have 1 characters.");
      return;
    }

    if (!validString(profile.first_name.trim())) {
      showErrorSnak("Please use english alphabets for first name.");
      return;
    }
    if (!validString(profile.last_name.trim())) {
      showErrorSnak("Please use english alphabets for last name.");
      return;
    }

    setIsLoading(true);
    let imageLink;
    if (image.preview !== "") {
      imageLink = await S3UploadFile(image.file);
    }

    let requestObj = {
      path: "/api/sale_team/edit_sale_man",
      method: "PUT",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      first_name: profile.first_name.trim(),
      last_name: profile.last_name.trim(),
      phone: profile.phone.trim(),
      email: profile.email.trim(),
      address: profile.address.trim(),
      profile_pic: image.preview === "" ? profile.profile_pic : imageLink,
    };
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        setImage({
          file: "",
          preview: "",
        });
        GetForemanProfile("done");

        showSuccessSnak("Profile updated successfully");
        setErrMessage("");
      } else {
        setIsLoading(false);
        setErrMessage(res.message);
        //showErrorSnak(res.message);
      }
    });
  };

  useEffect(() => {
    GetForemanProfile();
  }, []);

  if (isLoading) {
    return (
      <>
        <section id="content-wrapper" className="content-wrapper calendar-page">
          <div className="container-fluid">
            <p className="small-text-bold page-title">
              <img
                className="pointer-point pr-1"
                src={blackBackArrowImage}
                onClick={() => props.history.goBack()}
              />
              <span>Edit Profile</span>
            </p>
            <div className="Circular-Progress">
              <CircularProgress />
            </div>
          </div>
        </section>
      </>
    );
  }

  if (screen === "CHANGE_EMAIL") {
    return (
      <ChangeEmail
        GetForemanProfile={GetForemanProfile}
        setIsLoading={setIsLoading}
        profile={profile}
        setMainScreen={setScreen}
      />
    );
  }

  if (screen === "CHANGE_PHONE") {
    return (
      <ChangePhone
        GetForemanProfile={GetForemanProfile}
        setIsLoading={setIsLoading}
        profile={profile}
        setMainScreen={setScreen}
      />
    );
  }

  return (
    <>
      <section id="content-wrapper" className="content-wrapper calendar-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title">
            <img
              className="pointer-point pr-1"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Edit Profile</span>
          </p>
          <div className="calendar-wrapper">
            <div className="row justify-content-center pt-40">
              <div className="col-10  col-md-6 col-xl-5">
                {errMessage && (
                  <Alert variant="filled" severity="error">
                    {errMessage}
                  </Alert>
                )}
                <div className="form-box-wrapper">
                  <div className="form-box">
                    <h5 className="text-center">Edit Profile</h5>
                    <div className="evom-form login-form">
                      <form onSubmit={handleSubmit}>
                        <div className="form-group text-center">
                          {image.preview === "" ? (
                            //if preview is empty show default
                            profile.profile_pic ? (
                              //if profile picture is available show profile
                              <img
                                src={s3baseUrl + profile.profile_pic}
                                className="circle-box rounded-circle edit-profile-img"
                              />
                            ) : (
                              //else show default picture
                              <Avatar
                                style={{
                                  width: 150,
                                  height: 150,
                                  fontSize: 22,
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                }}
                              ></Avatar>
                            )
                          ) : (
                            //show preview
                            <img
                              src={image.preview}
                              className="circle-box rounded-circle edit-profile-img"
                            />
                          )}
                          <div className="edit-profile-icon">
                            <input
                              accept="image/*"
                              className={classes.input}
                              id="icon-button-file"
                              type="file"
                              value=""
                              onChange={handleUpload}
                            />
                            <label htmlFor="icon-button-file">
                              <IconButton
                                color="primary"
                                aria-label="upload picture"
                                component="span"
                              >
                                <PhotoCamera style={{ color: "#c4314b" }} />
                              </IconButton>
                            </label>
                          </div>
                        </div>

                        {/* edit phone and email */}

                        <div className="form-group">
                          <label
                            htmlFor="company_name"
                            className="overline dark-grey-color"
                          >
                            Email:
                          </label>

                          <span className="dark-grey-color pl-2">
                            {profile.email}
                          </span>

                          <img
                            className="float-right pointer-point"
                            sizes="10"
                            onClick={() => {
                              GetForemanProfile();
                              setScreen("CHANGE_EMAIL");
                            }}
                            src={editIconImage}
                          ></img>
                        </div>

                        <div className="form-group">
                          <label
                            htmlFor="company_name"
                            className="overline dark-grey-color"
                          >
                            Phone:
                          </label>
                          <span className="dark-grey-color pl-2">
                            {profile.phone}
                          </span>
                          <img
                            onClick={() => {
                              GetForemanProfile();
                              setScreen("CHANGE_PHONE");
                            }}
                            className="float-right pointer-point"
                            sizes="10"
                            src={editIconImage}
                          ></img>
                        </div>

                        <div className="form-group">
                          <label
                            htmlFor="company_name"
                            className="overline dark-grey-color"
                          >
                            FIRST NAME
                          </label>
                          <input
                            onChange={(e) =>
                              setProfile({
                                ...profile,
                                first_name: e.target.value.trim(),
                              })
                            }
                            required
                            value={profile.first_name}
                            type="text"
                            className="form-control small-font-size"
                            id="company_name"
                            placeholder="First Name"
                            autoComplete="off"
                          />
                        </div>
                        <div className="form-group">
                          <label
                            htmlFor="about_company"
                            className="overline dark-grey-color"
                          >
                            LAST NAME
                          </label>
                          <input
                            onChange={(e) =>
                              setProfile({
                                ...profile,
                                last_name: e.target.value.trim(),
                              })
                            }
                            autoComplete="off"
                            value={profile.last_name}
                            type="text"
                            className="form-control small-font-size"
                            id="about_company"
                            placeholder="Last Name"
                          />
                        </div>

                        {/* <div className="form-group">
                          <label
                            htmlFor="about_company"
                            className="overline dark-grey-color"
                          >
                            Address
                          </label>
                          <input
                            onChange={(e) =>
                              setProfile({
                                ...profile,
                                address: e.target.value,
                              })
                            }
                            autoComplete="off"
                            value={profile.address}
                            type="text"
                            className="form-control small-font-size"
                            id="address"
                            placeholder="Enter your address"
                          />
                        </div> */}

                        <div className="form-group button-wrapper">
                          <button
                            type="submit"
                            className="custom-buton custom-buton-large w-100"
                          >
                            Update Profile
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default withRouter(EditProfile);
